module.exports = __webpack_public_path__ + "static/media/r14.a2fae41c.png";